var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4577 0.218882C19.8523 0.492299 20.0593 0.964918 19.9851 1.43754L17.4848 17.6863C17.4262 18.0652 17.1957 18.3972 16.8597 18.5846C16.5237 18.7721 16.1213 18.7956 15.7658 18.6471L10.8316 16.5965L9.26498 19.5064C9.06183 19.8853 8.62818 20.0767 8.21016 19.9713C7.79214 19.8658 7.49914 19.4908 7.49914 19.0612V15.3115C7.49914 15.1044 7.56946 14.9013 7.69838 14.7373L14.1562 6.43324C14.2539 6.15592 13.9023 5.87469 13.6483 6.10514L6.65528 12.4289L5.40512 13.5577C5.0457 13.8819 4.53392 13.9717 4.08464 13.7842L0.763909 12.4015C0.326353 12.218 0.0294409 11.8039 0.00209369 11.3274C-0.0252535 10.8509 0.216965 10.4017 0.631079 10.1634L18.1333 0.164199C18.5513 -0.0740636 19.067 -0.050628 19.4616 0.218882H19.4577Z",
    fill: "#CB8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/Send-icon.f742b362b7af884d488bf8e4b0d4af1a.svg";
export { ForwardRef as ReactComponent };